<template>
<div>
  <div class="m-0 h-screen-fixed fixed pin pbc-modal-background flex justify-center left-0 top-0 right-0 bottom-0 inset-y-auto pbc-z-level-2 flex flex-col" @click.self='$emit("close")'>
    <button class="absolute top-0 right-0 mt-4 mr-4 text-white" @click='$emit("close")'>
      <close />
    </button>
    <div class="w-full mx-2 md:mx-auto md:w-2/3 self-center">
      <div class="m-2 rounded grow flex flex-col overflow-hidden" style='box-sizing: border-box' :class='bgcolor'>
        <div class="text-center flex justify-center">
          <slot />
        </div>
      </div>
    </div>
	</div>
</div>
</template>
<script>
import Close from '@icons/Close.vue';
export default {
  props:{
    bgcolor:{
      type:String,
      default:'bg-gray-500'
    }
  },
  components:{
    Close
  },
  mounted() {
    this.$store.commit('popupBeingShown', true);
  },
  beforeDestroy() {
    this.$store.commit('popupBeingShown', false);
  },
  data() {
    return {
    }
  },
  methods:{
  }
}
</script>
